module.exports = __webpack_public_path__ + "img/grifols-logo.6feab006.jpg";